import cn from 'classnames';
import React from 'react';

import {DEFAULT_IMAGE_HEIGHT} from '~/constants';

import './checkImages.scss';

interface IEImage {
  width: string | number;
  rotate?: number;
  color?: string;
  className?: string;
}

const EImage = ({
  width = `${DEFAULT_IMAGE_HEIGHT}mm`,
  rotate = 0,
  color = '#000000',
  className,
}: IEImage): JSX.Element => (
  <div
    className={cn('e-image-wrapper', className)}
    style={{
      width: width,
      height: width,
      backgroundColor: color,
      transform: `rotate(${rotate}deg)`,
    }}
  >
    <div className="e-image-light-line-1" />
    <div className="e-image-light-line-2" />
  </div>
);

export default EImage;
